// frontend/src/network.js
import { io } from "socket.io-client";
import { isLocal } from "./api/config.js";

const BACKEND_URL = isLocal
  ? "http://localhost:3000"
  : "https://api.arikarino.com";

class NetworkManager {
  constructor() {
    this.socket = null;
    this.players = new Map();
  }

  connect(initialTile = { xPos: 0, yPos: 0 }) {
    this.socket = io(BACKEND_URL, {
      path: "/magic-idle/socket.io/",
      transports: ["websocket", "polling"]
    });

    this.socket.on("connect", () => {
      console.log("[Network] Successfully connected to server! Socket ID:", this.socket.id);

      // Tell server we joined
      this.socket.emit("join_game", {
        world_id: "world_1",
        user_tile: initialTile
      });
    });

    this.socket.on("disconnect", (reason) => {
      console.warn("[Network] Disconnected:", reason);
    });

    this.listenToEvents();
  }

  listenToEvents() {
    this.socket.on("game_init", (data) => {
      this.players.clear();
      data.players.forEach(p => this.players.set(p.userId, p));
      if (this.onWorldUpdate) this.onWorldUpdate();
    });

    this.socket.on("player_joined", (data) => {
      this.players.set(data.userId, data);
      if (this.onWorldUpdate) this.onWorldUpdate();
    });

    this.socket.on("player_moved", (data) => {
      this.players.set(data.userId, data);
      if (this.onWorldUpdate) this.onWorldUpdate();
    });

    this.socket.on("player_left", (data) => {
      this.players.delete(data.userId);
      if (this.onWorldUpdate) this.onWorldUpdate();
    });

    this.socket.on("receive_chat_message", (data) => {
      if (this.onChatMessage) {
        this.onChatMessage(data);
      }
    });
  }

  sendChatMessage(message) {
    if (!this.socket || !this.socket.connected) return;

    this.socket.emit("send_chat_message", {
      message: message
    });
  }

  // Send a movement packet to the server
  sendMove(xPos, yPos) {
    if (!this.socket || !this.socket.connected) return;

    this.socket.emit("move_player", {
      user_tile: { xPos, yPos }
    });
  }
}




export const network = new NetworkManager();